import { render } from "./index.vue?vue&type=template&id=ab73105c&scoped=true&bindings={}"
import script from "./artist-info.js?vue&type=script&lang=js"
export * from "./artist-info.js?vue&type=script&lang=js"

import "./artist-info.scss?vue&type=style&index=0&id=ab73105c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ab73105c"

export default script